import React from "react";

import { ContentModule } from "utils/orm";
import { ContentMapper } from "components/ContentMapper";

interface ArticleBodyProps {
    articleContentModules: ContentModule[];
    blockHeadingPrefix?: string;
    listBuilder?: ContentModule[];
    postListBodyContent?: ContentModule[];
    templateName: string;
    tocEntities: Array<{ heading: string; id: number }>;
}

const ArticleBody = (props: ArticleBodyProps) => {
    const {
        articleContentModules,
        blockHeadingPrefix,
        listBuilder,
        postListBodyContent,
        templateName,
        tocEntities
    } = props;
    const contentProps = { modules: articleContentModules, templateName, tocEntities };

    const listBuilderProps = {
        modules: listBuilder, templateName, hasBullets: true, prefix: blockHeadingPrefix
    };
    const postBodyProps = { modules: postListBodyContent, templateName };

    return (
        <>
            {ContentMapper(contentProps)}
            {listBuilder && ContentMapper(listBuilderProps)}
            {postListBodyContent && ContentMapper(postBodyProps)}
        </>
    );
};

export { ArticleBody };
